// extracted by mini-css-extract-plugin
module.exports = {"component__btn":"DynamicButton_component__btn___J_Tp"};